import { styled } from '@mui/material/styles';
import LinkwithModal from '../LinkWithModal';
import { DEFAULT_PRIMARY_SEMIBOLD_FONT } from 'theme/fontDefaults';
// import { Link } from '@sitecore-jss/sitecore-jss-nextjs';

enum Link {
  contained = 'contained',
  outlined = 'outlined',
  text = 'text',
}

export type LinkType = keyof typeof Link;

// JSS link that looks like a button and can be used for client side transitions between routes
export const JSSLink = styled(LinkwithModal, {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'tabIndex',
})<{ variant?: LinkType; tabIndex?: any }>(({ theme, variant }) => ({
  display: 'inline-block',
  fontFamily: `${
    theme?.palette?.primaryFontSemiBoldType || DEFAULT_PRIMARY_SEMIBOLD_FONT
  }, sans-serif`,
  fontSize: '1rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  filter:
    variant === 'contained'
      ? 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.50))'
      : 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.08))',
  fontStyle: 'normal',
  lineHeight: '2.5rem',
  color:
    variant === 'contained'
      ? theme.buttonStyle?.primary?.textColor.default || theme?.palette?.white?.main
      : variant === 'outlined'
      ? theme.buttonStyle?.secondary?.textColor.default || theme.palette.primary?.main
      : theme.palette.primary?.main,
  textDecoration: 'none',
  textTransform: 'none',
  borderRadius:
    variant === 'contained'
      ? theme.buttonStyle?.primary?.borderRadius || '50px'
      : variant === 'outlined'
      ? theme.buttonStyle?.secondary?.borderRadius || '50px'
      : variant === 'text'
      ? theme.buttonStyle?.discreet?.borderRadius
      : '0px',
  height: 'auto',
  minWidth: variant === 'contained' || variant === 'outlined' ? '205px' : '0px',
  textAlign: 'center',
  padding:
    variant === 'contained' || variant === 'outlined' || variant === 'text' ? '1px 10px' : '1px',
  border:
    variant === 'contained'
      ? `1px solid ${
          theme.buttonStyle?.primary?.borderColor?.default || theme.palette.primary?.main
        }`
      : variant === 'outlined'
      ? `1px solid ${
          theme.buttonStyle?.secondary?.borderColor?.default || theme.palette.neutral4?.main
        }`
      : 'none',
  background:
    variant === 'contained'
      ? theme.buttonStyle?.primary?.background.default || theme.palette.primary?.main
      : variant === 'outlined'
      ? theme.buttonStyle?.secondary?.background.default || theme.palette.secondary?.main
      : 'none',
  '&:hover': {
    background:
      variant === 'contained'
        ? theme.buttonStyle?.primary?.background.hover || theme.palette.primary?.dark
        : variant === 'outlined'
        ? theme.buttonStyle?.secondary?.background.hover || theme.palette.secondary?.dark
        : variant === 'text'
        ? theme.buttonStyle?.discreet?.background.hover
        : 'none',
    textDecoration: 'none',
    border:
      variant === 'contained'
        ? `1px solid ${
            theme.buttonStyle?.primary?.borderColor?.hover || theme.palette.primary?.main
          }`
        : variant === 'outlined'
        ? `1px solid ${
            theme.buttonStyle?.secondary?.borderColor?.hover || theme.palette.primary?.main
          }`
        : 'none',
    borderBottom:
      variant === 'contained'
        ? `1px solid ${
            theme.buttonStyle?.primary?.borderColor?.hover || theme.palette.primary?.main
          }`
        : variant === 'outlined'
        ? `1px solid ${
            theme.buttonStyle?.secondary?.borderColor?.hover || theme.palette.primary?.main
          }`
        : variant === 'text'
        ? 'none'
        : '1px dashed',
    color:
      variant === 'outlined'
        ? theme.buttonStyle?.secondary?.textColor.hover || theme.palette.primary?.main
        : variant === 'text'
        ? theme.buttonStyle?.discreet?.textColor.hover
        : theme.buttonStyle?.primary?.textColor.hover || theme?.palette?.white?.main,
  },
  [theme.breakpoints.down('sm')]: {
    lineHeight: '1.5rem',
  },
}));
